<template>
  <div>
    <!-- <div class="home-two"> -->
    <Header />
    <!-- </div> -->
    <transition name="fade" mode="out-in">
      <router-view> <!--v-slot="{ Component }"-->
          <!-- <component :is="Component" /> -->
      </router-view>
    </transition>

    <Footer />

  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default {
  components: {
    Header,
    Footer,
  },
  methods: {
    Push() {
      this.$router.push('/demo')
    },
    afterEnter: () => {
      window.scrollTo(0, 0);
    },
    afterLeave: () => {
      // Store.commit("setPageTransition", "default");
    },
  },
  mounted() {
    console.log(this.$route.fullPath)
  },
}
</script>

<style lang="css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}


.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>